<template lang="pug">
  .hcb-location-page.container
    SiteMessageBannerCarousel(:topics="siteMessageTopics")

    .row
      HairColorBarLocationHero(:hero-settings="heroSettings")

    .row
      ServicesList(:services="cmsSettings.servicesList" :title="cmsSettings.servicesTitle" :location="location")

    .row.xs-mb-200m.md-mb-300m
      HcbLocationReviews(:section-title="cmsSettings.reviewSectionTitle")

    .row.xs-mb-200m
      DashHudsonScript
        template(#title="")
          h3.bold.upper.xs-f-small.md-f-small.lg-f-large.max-at-tweak.text-center Real clients, really gorgeous results

    .row
      LocationFAQs(v-if="faqs.length" :faqs="faqs" :cmsSettings="cmsSettings")

    .row
      CMSPartial(mixin-key="partial-our-colorists")

</template>

<script>

  import SiteMessageBannerCarousel from "@components/SiteMessageBannerCarousel/SiteMessageBannerCarousel.vue";
  import HcbLocationReviews from "@components/HairColorBar/HcbLocationPage/HcbLocationReviews";
  import HairColorBarLocationHero from '@components/HairColorBar/HcbIndividual/HairColorBarLocationHero';
  import LocationFAQs from './LocationFAQs';
  import ServicesList from "./ServicesList/";
  import { mapActions, mapMutations, mapState } from "vuex";
  import CMSPartial from "@components/CMSPartial/CMSPartial.vue";
  import DashHudsonScript from "@components/PDP/DashHudsonScript.vue";

  export default {
    name: "HcbLocationPage",

    components: {
      DashHudsonScript,
      CMSPartial,
      SiteMessageBannerCarousel,
      HcbLocationReviews,
      HairColorBarLocationHero,
      LocationFAQs,
      ServicesList
    },

    inject: ['getObjProperty'],

    props: {
      cmsSettings: {
        type: Object,
        default: () => ({}),
      },
      routeParams: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      ...mapState('colorbar', [
        'location',
        'locationLoading'
      ]),

      siteMessageTopics() {
        let topics = ['hcb-all-landing'];

        if (this.routeParams.locationCode) {
          topics.push(`hcb-${this.routeParams.locationCode}-landing`);
        }

        return topics.join(',');
      },

      heroSettings() {
        return this.cmsSettings?.hero || {};
      },

      faqs() {
        let faqs = [];
        if (this.cmsSettings?.faqs?.length) {
          this.cmsSettings.faqs.map((faq) => { faqs.push(faq); });
        }
        if (this.location?.cmsData?.faqs?.length) {
          this.location.cmsData.faqs.map((faq) => { faqs.push(faq); });
        }
        return faqs;
      }

    },

    methods: {
      ...mapActions('colorbar', ['loadLocation']),

      ...mapMutations('global', [
        'setBreadcrumbs',
        'resetBreadcrumbs'
      ]),

      setBreadcrumbFragments() {
        let fragments = [];

        fragments.push({ title: 'Home', url: '/' });
        fragments.push({ title: 'Hair Color Bar', url: '/colorbar' });
        fragments.push({ title: 'Locations', url: '/colorbar/locations' });

        if (this.getObjProperty(this.location, 'region.name')) {
          fragments.push({ title: this.location.region.name, url: `/colorbar/regions/${this.location.region.url_key}` });
        }

        if (this.getObjProperty(this.location, 'name')) {
          fragments.push({ title: this.location.name });
        }

        if (fragments.length) {
          this.setBreadcrumbs(fragments);
        }
      },
    },

    async serverPrefetch() {
      await this.loadLocation(this.routeParams.locationCode);
    },

    mounted() {
      this.setBreadcrumbFragments();
    },

    unmounted() {
      this.resetBreadcrumbs();
    },
  };
</script>


<style scoped lang="stylus">

</style>
